<template>
  <!-- 页面内图标 sprite：jp- 前缀避免与全局 svg sprite 的 symbol id 冲突。
       三个路由页各引入一份，同一时刻只挂载一个页面，重复 id 无副作用 -->
  <svg width="0" height="0" style="position: absolute" aria-hidden="true">
    <symbol id="jp-upload" viewBox="0 0 24 24"><path d="M12 16V4M7 9l5-5 5 5" /><path d="M5 13v7h14v-7" /></symbol>
    <symbol id="jp-download" viewBox="0 0 24 24"><path d="M12 4v11M7 10l5 5 5-5" /><path d="M5 20h14" /></symbol>
    <symbol id="jp-send" viewBox="0 0 24 24"><path d="m3 11 18-8-8 18-2-8z" /><path d="m11 13 10-10" /></symbol>
    <symbol id="jp-x" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></symbol>
    <symbol id="jp-check" viewBox="0 0 24 24"><path d="m5 12 4 4L19 6" /></symbol>
    <symbol id="jp-file" viewBox="0 0 24 24"><path d="M6 3h8l4 4v14H6z" /><path d="M14 3v5h5" /><path d="M9 13h6M9 17h4" /></symbol>
    <symbol id="jp-caret" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6" /></symbol>
    <symbol id="jp-left" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6" /></symbol>
    <symbol id="jp-search" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" /></symbol>
    <symbol id="jp-folder" viewBox="0 0 24 24"><path d="M3 6h7l2 2h9v11H3z" /></symbol>
  </svg>
</template>
